import React from "react";
import PATHS from "config/paths";

/* eslint-disable react-hooks/exhaustive-deps */

const cache = new Map();

export function useDeleteSurvivorAssociatedVictim(token, survivor_id, associated_id) {
  const [error, setError] = React.useState();
  const [isDeleteVictimAssociationComplete, setIsDeleteVictimAssociationComplete] = React.useState(false);

  React.useEffect(() => {
    if (token && survivor_id && associated_id) {        
        setError(undefined);

        const headers = new Headers();
        headers.append("Accept", "application/json");
        headers.append("Authorization", `Bearer ${token}`);
        headers.append("Origin", "{location.protocol + '//' + location.host}");
        const options = {
          method: "DELETE",
          headers: headers,
          redirect: "follow",
          cache: "no-cache",
        };

        /**
         * Make request
         */
        fetch(`${PATHS.apiSurvivors}/${survivor_id}/associate_victim/${associated_id}`, options)
          .then((response) => {
            setIsDeleteVictimAssociationComplete(true);
            return response.json();
          })
          .catch((error) => setError(error))
          
        }
    
  }, [token, survivor_id, associated_id]);

  return { isDeleteVictimAssociationComplete, deleteVictimAssociationError: error  };
}
